export function hostData(url: String, port?: String) {
  const domains: string[] = url.split('.').filter((item) => item !== 'www');
  const sub = domains.length > 2 ? domains[0] : '';
  const noSubArr = [
    'front-v3-test',
    'front-v3-test2',
    'front-v3',
    'frontv3-dev',
  ];
  const baseDomain = domains.slice(-2).join('.');
  const isSubdomain: boolean = !!sub && !noSubArr.includes(sub);
  const domain: string = isSubdomain
    ? domains.slice(1).join('.')
    : domains.join('.');
  const domainWithPort: string = domain + (port ? `:${port}` : '');
  return { domains, isSubdomain, domain, domainWithPort, baseDomain, sub };
}
